// extracted by mini-css-extract-plugin
module.exports = {"root":"ResolutionWrapper_root__CIdcw"};